import React from 'react'

export interface TrackOrderParams {
  email: string
  firstName: string
  lastName: string
  orderNumber: string
  itemTotal: string
  shippingTotal: string
  taxTotal: string
  handlingTotal: string
  orderTotal: string
  products: Array<{
    sku: string
    quantity: number
    price: string
  }>
}

export const trackOrder = (data: TrackOrderParams) => {
  const {
    email,
    firstName,
    lastName,
    orderNumber,
    itemTotal,
    shippingTotal,
    taxTotal,
    handlingTotal,
    orderTotal,
    products
  } = data

  // eslint-disable-next-line
  console.group('Listrak >> Conversion')

  // eslint-disable-next-line
  console.info(`_ltk.Order.SetCustomer('${email}', '${firstName}', '${lastName}')`)
  // @ts-expect-error
  window._ltk.Order.SetCustomer(email, firstName, lastName)

  // eslint-disable-next-line
  console.info(`_ltk.Order.OrderNumber = ${orderNumber}`)
  // @ts-expect-error
  window._ltk.Order.OrderNumber = orderNumber

  // eslint-disable-next-line
  console.info(`_ltk.Order.ItemTotal = ${itemTotal}`)
  // @ts-expect-error
  window._ltk.Order.ItemTotal = itemTotal

  // eslint-disable-next-line
  console.info(`_ltk.Order.ShippingTotal = ${shippingTotal}`)
  // @ts-expect-error
  window._ltk.Order.ShippingTotal = shippingTotal

  // eslint-disable-next-line
  console.info(`_ltk.Order.TaxTotal = ${taxTotal}`)
  // @ts-expect-error
  window._ltk.Order.TaxTotal = taxTotal

  // eslint-disable-next-line
  console.info(`_ltk.Order.HandlingTotal = ${handlingTotal}`)
  // @ts-expect-error
  window._ltk.Order.HandlingTotal = handlingTotal

  // eslint-disable-next-line
  console.info(`_ltk.Order.OrderTotal = ${orderTotal}`)
  // @ts-expect-error
  window._ltk.Order.OrderTotal = orderTotal

  products.forEach(product => {
    const { price, quantity, sku } = product
    // eslint-disable-next-line
    console.info(`_ltk.Order.AddItem('${sku}', ${quantity}, '${price}')`)
    // @ts-expect-error
    window._ltk.Order.AddItem(sku, quantity, price)
  })

  // eslint-disable-next-line
  console.info('_ltk.Order.Submit()')
  // @ts-expect-error
  window._ltk.Order.Submit()

  // eslint-disable-next-line
  console.groupEnd()
}

export const renderTrackingPixel = (): JSX.Element => {
  return <img src={`https://fp.listrakbi.com/fp/${process.env.REACT_APP_LISTRAK_MERCHANT_ID}.jpg`} alt='' height='1' width='1' />
}

export const trackProductBrowse = (skus: string[]) => {
  // eslint-disable-next-line
  console.group('Listrak >> Product Browse')

  skus.forEach(sku => {
    // eslint-disable-next-line
    console.info(`_ltk.Activity.AddProductBrowse('${sku}')`)
    // @ts-expect-error
    window._ltk.Activity?.AddProductBrowse(sku)
  })

  // eslint-disable-next-line
  console.info('_ltk.Activity.Submit()')
  // @ts-expect-error
  window._ltk.Activity?.Submit()

  // eslint-disable-next-line
  console.groupEnd()
}

export const captureEmail = (email: string) => {
  // eslint-disable-next-line
  console.group('Listrak >> Email')

  // eslint-disable-next-line
  console.info(`_ltk.SCA.Update('email', '${email}')`)
  // @ts-expect-error
  window._ltk.SCA.Update('email', email)

  // eslint-disable-next-line
  console.groupEnd()
}
